import { useEffect, useRef } from "react";
import { useWizardDispatch } from "./context/WizardContext";

/**
 * Reset the wizard reducer state (currentStep, stepValidity, isSubmitting)
 * on every open=false→true transition.
 *
 * WizardProvider is mounted outside SlidePanel and persists across open
 * toggles, so without this hook the wizard reopens on the last visited step
 * with stale validity flags. Mirrors useResetOnOpen for the RHF form.
 */
export function useResetWizardOnOpen(open: boolean, initialStep: number): void {
  const dispatch = useWizardDispatch();
  const wasOpenRef = useRef(false);
  useEffect(() => {
    if (open && !wasOpenRef.current) {
      dispatch({ type: "RESET", initialStep });
    }
    wasOpenRef.current = open;
  }, [open, initialStep, dispatch]);
}
